module.exports = __webpack_public_path__ + "static/media/icevi.20815dc1.pdf";